exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-cell[data-v-4832fe4e]{position:absolute;margin:-8px;font-size:16px;background:#fff;opacity:.9;border-radius:20px;-webkit-border-radius:20px;-moz-border-radius:20px;padding:2px;cursor:pointer;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4832fe4e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/order-layout/order-layout-box.vue
// module id = 4MiH
// module chunks = 50